{
  "sube": {
    "Baslik": "Filiaal Introductie",
    "Ad": "Naam",
    "Merkez": "Centraal?",
    "Durum": "Status",
    "Arama": "Zoeken",
    "Ara": "Zoeken",
    "Temizle": "Wissen",
    "Kapat": "Sluiten",
    "Yenile": "Vernieuwen",
    "Data Yenile": "Vergevens Vernieuwen",
    "Ekle": "Filiaal Toevoegen",
    "Filtrele": "Filteren",
    "Duzenle": "Bewerken",
    "Sil": "Verwijderen",
    "Kaydet": "Opslaan",
    "Guncelle": "Bijwerken",
    "Vazgec": "Annuleren",
    "Latitude": "Breedtegraad",
    "Longitude": "Lengtegraad",
    "Şube Tanıtım": "Filiaal Introductie"
  }
}
